exports = module.exports = require("../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._35OO2i8OKN_9qNVBxCkAUB{position:relative;margin:-1rem 0 3.25rem}._35OO2i8OKN_9qNVBxCkAUB img{-webkit-transform:translate(-50%, -50%);-ms-transform:translate(-50%, -50%);transform:translate(-50%, -50%);position:absolute;top:0;left:50%;max-width:4.5rem}\n", ""]);

// exports
exports.locals = {
	"iconIllustration": "_35OO2i8OKN_9qNVBxCkAUB"
};